import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Types //
export interface AiTypes {
  search: string | null
}

const initialState = {
  search: null,
} as AiTypes

const aiSlice = createSlice({
  name: 'Ai',
  initialState,
  reducers: {
    setAi: (
      state,
      action: PayloadAction<{
        search?: string
      }>
    ) => {
      const newState = {
        search: action.payload.search,
      }
      return { ...state, ...newState }
    },
  },
})

const { actions, reducer } = aiSlice
export const { setAi } = actions
export default reducer
